module.exports = __webpack_public_path__ + "static/media/AuthForm.04f74e58.pdf";